import { takeEvery } from 'redux-saga/effects'
import { putPromise } from '../../../helpers/redux'
import * as actions from './actions'
import { listPrompts } from './actions'

export function* refreshPromptsAfterMutation() {
  yield takeEvery(
    [actions.ADD_PROMPT_SUCCESS, actions.UPDATE_PROMPT_SUCCESS, actions.DELETE_PROMPT_SUCCESS],
    function* () {
      yield putPromise(listPrompts())
    },
  )
}
